import { Pressable as $e, Platform as Oe, Easing as d, Animated as h } from "react-native-web";
import { c as y } from "./chunks/BkfeUUK-/_commonjsHelpers.js";
import p, { useState as Re, useCallback as Se, createContext as We, forwardRef as Xe, useRef as Ye, useContext as Be, useMemo as De } from "react";
var k = {}, C = {};
Object.defineProperty(C, "__esModule", { value: !0 });
C.clearAnimationFrameOnce = C.animationFrameOnce = C.hasAnimationFrameOnce = void 0;
const A = {};
function He(e) {
  return !!A[e];
}
C.hasAnimationFrameOnce = He;
function Le(e, n) {
  const t = A[e];
  t && cancelAnimationFrame(t), A[e] = requestAnimationFrame(() => {
    delete A[e], n();
  });
}
C.animationFrameOnce = Le;
function Ne(e) {
  const n = A[e];
  n && (cancelAnimationFrame(n), delete A[e]);
}
C.clearAnimationFrameOnce = Ne;
var P = {};
Object.defineProperty(P, "__esModule", { value: !0 });
P.arrayInsertSorted = P.arrayRemoveAt = P.arrayRemove = void 0;
function Ke(e, n) {
  const t = e.indexOf(n);
  return t >= 0 && e.splice(t, 1), t;
}
P.arrayRemove = Ke;
function qe(e, n) {
  return e.splice(n, 1)[0];
}
P.arrayRemoveAt = qe;
function Ze(e, n, t) {
  let r = 0, i = e.length - 1;
  for (; r <= i; ) {
    const u = r + i >> 1, o = t(e[u], n);
    if (o < 0)
      r = u + 1;
    else if (o > 0)
      i = u - 1;
    else
      return u;
  }
  return r;
}
function Ge(e, n, t) {
  const r = Ze(e, n, t);
  return e.splice(r, 0, n), r;
}
P.arrayInsertSorted = Ge;
var f = {};
Object.defineProperty(f, "__esModule", { value: !0 });
f.isObjectEmpty = f.isFunction = f.isBoolean = f.isNumber = f.isObject = f.isString = f.isArray = void 0;
function Ce(e) {
  return Array.isArray(e);
}
f.isArray = Ce;
function Je(e) {
  return typeof e == "string";
}
f.isString = Je;
function Pe(e) {
  return typeof e == "object" && e !== null && !Ce(e);
}
f.isObject = Pe;
function Qe(e) {
  return typeof e == "number" && !isNaN(e);
}
f.isNumber = Qe;
function Ue(e) {
  return e === !0 || e === !1;
}
f.isBoolean = Ue;
function xe(e) {
  return typeof e == "function";
}
f.isFunction = xe;
function en(e) {
  return e && Pe(e) && Object.keys(e).length === 0;
}
f.isObjectEmpty = en;
var Q = {};
Object.defineProperty(Q, "__esModule", { value: !0 });
Q.PromiseCallback = void 0;
class nn {
  constructor() {
    this.promise = new Promise((n) => this._resolve = n);
  }
  get isResolved() {
    return this._isResolved;
  }
  resolve(n) {
    this._isResolved = !0, this._resolve(n);
  }
}
Q.PromiseCallback = nn;
var M = {};
Object.defineProperty(M, "__esModule", { value: !0 });
M.polyfillResizeObserver = M.ResizeObserver = void 0;
let we = typeof window < "u" && window?.ResizeObserver;
M.ResizeObserver = we;
const tn = function(n) {
  M.ResizeObserver = we = window?.ResizeObserver || n;
};
M.polyfillResizeObserver = tn;
var w = {};
Object.defineProperty(w, "__esModule", { value: !0 });
w.clearTimeoutOnce = w.timeoutOnce = w.hasTimeoutOnce = void 0;
const $ = {};
function rn(e) {
  return !!$[e];
}
w.hasTimeoutOnce = rn;
function un(e, n, t, ...r) {
  const i = $[e];
  i && clearTimeout(i), $[e] = setTimeout(() => {
    delete $[e], n(...r);
  }, t);
}
w.timeoutOnce = un;
function on(e) {
  const n = $[e];
  n && (clearTimeout(n), delete $[e]);
}
w.clearTimeoutOnce = on;
(function(e) {
  var n = y && y.__createBinding || (Object.create ? function(r, i, u, o) {
    o === void 0 && (o = u);
    var m = Object.getOwnPropertyDescriptor(i, u);
    (!m || ("get" in m ? !i.__esModule : m.writable || m.configurable)) && (m = { enumerable: !0, get: function() {
      return i[u];
    } }), Object.defineProperty(r, o, m);
  } : function(r, i, u, o) {
    o === void 0 && (o = u), r[o] = i[u];
  }), t = y && y.__exportStar || function(r, i) {
    for (var u in r) u !== "default" && !Object.prototype.hasOwnProperty.call(i, u) && n(i, r, u);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), t(C, e), t(P, e), t(f, e), t(Q, e), t(M, e), t(w, e);
})(k);
const an = 300;
function le() {
  return le = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, le.apply(this, arguments);
}
const je = /* @__PURE__ */ We({
  pressed: !1,
  hovered: !1
});
function sn(e) {
  const {
    onPressIn: n,
    onPressOut: t,
    onMouseEnter: r,
    onMouseLeave: i,
    children: u,
    ...o
  } = e, [m, v] = Re({
    pressed: !1,
    hovered: !1
  }), l = Se((a, g) => {
    v((Y) => ({
      pressed: a ?? Y.pressed,
      hovered: g ?? Y.hovered
    }));
  }, []);
  return /* @__PURE__ */ p.createElement($e, le({
    onPressIn: (a) => {
      l(!0, void 0), n?.(a);
    },
    onPressOut: (a) => {
      l(!1, void 0), t?.(a);
    },
    onMouseEnter: Oe.OS === "web" ? (a) => {
      l(void 0, !0), r?.(a);
    } : void 0,
    onMouseLeave: Oe.OS === "web" ? (a) => {
      l(void 0, !1), i?.(a);
    } : void 0
  }, o), /* @__PURE__ */ p.createElement(je.Provider, {
    value: m
  }, u));
}
var Me = {}, U = {};
Object.defineProperty(U, "__esModule", { value: !0 });
U.useEverHadValue = void 0;
const cn = p, ln = function(n, t) {
  const r = (0, cn.useRef)(!1);
  return r.current = r.current || n === t, r.current;
};
U.useEverHadValue = ln;
var q = {};
Object.defineProperty(q, "__esModule", { value: !0 });
q.useForceRender = void 0;
const fn = p;
function dn() {
  const [, e] = (0, fn.useReducer)((n) => n + 1, 0);
  return e;
}
q.useForceRender = dn;
var Z = {};
Object.defineProperty(Z, "__esModule", { value: !0 });
Z.useMakeRef = void 0;
const mn = p;
function vn(e) {
  const n = (0, mn.useRef)();
  return n.current = e, n;
}
Z.useMakeRef = vn;
var x = {};
Object.defineProperty(x, "__esModule", { value: !0 });
x.usePrevious = void 0;
const pn = p;
function bn(e) {
  const n = (0, pn.useRef)(), t = n.current;
  return n.current = e, t;
}
x.usePrevious = bn;
var ee = {};
Object.defineProperty(ee, "__esModule", { value: !0 });
ee.useStateWithRef = void 0;
const se = p, On = f;
function gn(e) {
  const [n, t] = (0, se.useState)(e), r = (0, se.useRef)(n), i = (0, se.useCallback)((u) => {
    (0, On.isFunction)(u) && (u = u(r.current)), r.current = u, t(u);
  }, []);
  return [n, i, r];
}
ee.useStateWithRef = gn;
var ne = {};
Object.defineProperty(ne, "__esModule", { value: !0 });
ne.useInterval = void 0;
const hn = p;
function yn(e, n) {
  (0, hn.useEffect)(() => {
    if (e && n !== void 0 && n !== null) {
      const t = setInterval(e, n);
      return () => clearInterval(t);
    }
  }, [n, e]);
}
ne.useInterval = yn;
var te = {};
Object.defineProperty(te, "__esModule", { value: !0 });
te.useTimeout = void 0;
const _n = p, Rn = (e, n) => {
  (0, _n.useEffect)(() => {
    if (n !== null) {
      const t = setTimeout(e, n);
      return () => clearTimeout(t);
    }
  }, []);
};
te.useTimeout = Rn;
var re = {};
Object.defineProperty(re, "__esModule", { value: !0 });
re.useStableCallback = void 0;
const Sn = Z, Cn = p;
function Pn(e) {
  const n = (0, Sn.useMakeRef)(e);
  return (0, Cn.useCallback)((...t) => {
    var r;
    (r = n.current) === null || r === void 0 || r.call(n, ...t);
  }, []);
}
re.useStableCallback = Pn;
var X = {};
Object.defineProperty(X, "__esModule", { value: !0 });
X.useComponentSizeChange = X.useComponentSize = void 0;
const W = p, Fe = M, wn = q;
function ze(e) {
  return e ? {
    width: e.offsetWidth,
    height: e.offsetHeight
  } : {
    width: 0,
    height: 0
  };
}
const jn = function(n) {
  const t = (0, W.useRef)({ width: 0, height: 0 }), r = (0, wn.useForceRender)(), i = (0, W.useCallback)(() => {
    if (n.current) {
      const u = t.current, o = ze(n.current);
      o && (o.width !== u.width || o.height !== u.height) && (t.current = o, r());
    }
  }, [n, r]);
  return (0, W.useLayoutEffect)(() => {
    const u = n.current;
    if (u) {
      i();
      let o = new Fe.ResizeObserver(i);
      return o.observe(u), () => {
        o.disconnect(), o = void 0;
      };
    }
  }, [n.current]), t.current;
};
X.useComponentSize = jn;
const Mn = function(n, t) {
  const r = (0, W.useRef)({ width: 0, height: 0 }), i = (0, W.useCallback)(() => {
    if (n.current) {
      const u = r.current, o = ze(n.current);
      o && (o.width !== u.width || o.height !== u.height) && (r.current = o, t?.(o));
    }
  }, [n, t]);
  return (0, W.useEffect)(() => {
    const u = n.current;
    if (u) {
      i();
      let o = new Fe.ResizeObserver(i);
      return o.observe(u), () => {
        o.disconnect(), o = void 0;
      };
    }
  }, [n.current]), r.current;
};
X.useComponentSizeChange = Mn;
var j = {}, Fn = y && y.__createBinding || (Object.create ? function(e, n, t, r) {
  r === void 0 && (r = t);
  var i = Object.getOwnPropertyDescriptor(n, t);
  (!i || ("get" in i ? !n.__esModule : i.writable || i.configurable)) && (i = { enumerable: !0, get: function() {
    return n[t];
  } }), Object.defineProperty(e, r, i);
} : function(e, n, t, r) {
  r === void 0 && (r = t), e[r] = n[t];
}), zn = y && y.__setModuleDefault || (Object.create ? function(e, n) {
  Object.defineProperty(e, "default", { enumerable: !0, value: n });
} : function(e, n) {
  e.default = n;
}), En = y && y.__importStar || function(e) {
  if (e && e.__esModule) return e;
  var n = {};
  if (e != null) for (var t in e) t !== "default" && Object.prototype.hasOwnProperty.call(e, t) && Fn(n, e, t);
  return zn(n, e), n;
};
Object.defineProperty(j, "__esModule", { value: !0 });
j.MemoFnComponentWithRef = j.MemoFnComponent = j.configureMemoFnComponent = void 0;
const S = En(p);
let E = {};
function In(e) {
  E = e || {};
}
j.configureMemoFnComponent = In;
class Ee extends S.Component {
  constructor(n) {
    super(n), this.state = {
      error: null
    };
  }
  componentDidCatch(n, t) {
    if (E.onError)
      try {
        let r;
        this.props.onError && (r = this.props.onError(n, t)), r || E.onError(n, t);
      } catch (r) {
        console.log(r);
      }
    this.setState({ error: n });
  }
  render() {
    const { children: n } = this.props, { error: t } = this.state;
    if (t !== null) {
      debugger;
      return null;
    }
    return n || null;
  }
}
function Tn(e, n) {
  n = n || E.onError;
  let t = e;
  if (n) {
    const r = E.ErrorBoundary || Ee;
    t = (i) => S.default.createElement(r, { onError: n }, (0, S.createElement)(e, i));
  }
  return (0, S.memo)(t);
}
j.MemoFnComponent = Tn;
function Vn(e, n) {
  let t = e;
  if (n = n || E.onError, n) {
    const r = E.ErrorBoundary || Ee, i = (u, o) => S.default.createElement(r, { onError: n }, (0, S.createElement)(e, Object.assign({ ref: o }, u)));
    t = (0, S.forwardRef)(i);
  }
  return (0, S.memo)(t);
}
j.MemoFnComponentWithRef = Vn;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.MemoFnComponentWithRef = e.MemoFnComponent = e.configureMemoFnComponent = e.useComponentSizeChange = e.useComponentSize = e.useStableCallback = e.useTimeout = e.useInterval = e.useStateWithRef = e.usePrevious = e.useMakeRef = e.useForceRender = e.useEverHadValue = void 0;
  var n = U;
  Object.defineProperty(e, "useEverHadValue", { enumerable: !0, get: function() {
    return n.useEverHadValue;
  } });
  var t = q;
  Object.defineProperty(e, "useForceRender", { enumerable: !0, get: function() {
    return t.useForceRender;
  } });
  var r = Z;
  Object.defineProperty(e, "useMakeRef", { enumerable: !0, get: function() {
    return r.useMakeRef;
  } });
  var i = x;
  Object.defineProperty(e, "usePrevious", { enumerable: !0, get: function() {
    return i.usePrevious;
  } });
  var u = ee;
  Object.defineProperty(e, "useStateWithRef", { enumerable: !0, get: function() {
    return u.useStateWithRef;
  } });
  var o = ne;
  Object.defineProperty(e, "useInterval", { enumerable: !0, get: function() {
    return o.useInterval;
  } });
  var m = te;
  Object.defineProperty(e, "useTimeout", { enumerable: !0, get: function() {
    return m.useTimeout;
  } });
  var v = re;
  Object.defineProperty(e, "useStableCallback", { enumerable: !0, get: function() {
    return v.useStableCallback;
  } });
  var l = X;
  Object.defineProperty(e, "useComponentSize", { enumerable: !0, get: function() {
    return l.useComponentSize;
  } }), Object.defineProperty(e, "useComponentSizeChange", { enumerable: !0, get: function() {
    return l.useComponentSizeChange;
  } });
  var a = j;
  Object.defineProperty(e, "configureMemoFnComponent", { enumerable: !0, get: function() {
    return a.configureMemoFnComponent;
  } }), Object.defineProperty(e, "MemoFnComponent", { enumerable: !0, get: function() {
    return a.MemoFnComponent;
  } }), Object.defineProperty(e, "MemoFnComponentWithRef", { enumerable: !0, get: function() {
    return a.MemoFnComponentWithRef;
  } });
})(Me);
function ge(e, n) {
  const t = k.isString(e), r = t && e.endsWith("%");
  let i = t ? +e.replace(/%|px/, "") : e;
  const u = r ? +i / 100 : +i / n;
  return isNaN(u) ? i = 0 : i = (u - 0.5) * n, i;
}
const kn = function(n, t, r) {
  let i = r, u = !1, o = !1;
  if (n) {
    let {
      x: v,
      y: l
    } = n;
    u = v !== void 0 && v !== "50%", o = l !== void 0 && l !== "50%";
  }
  if (Me.useEverHadValue(!!n, !0)) {
    const [v, l] = Re({
      width: 0,
      height: 0
    });
    if (i = Se((a) => {
      l(a.nativeEvent.layout), r?.(a);
    }, [r]), n && t) {
      let {
        x: a,
        y: g
      } = n;
      a = u ? ge(a, v.width) : 0, g = o ? ge(g, v.height) : 0, t.splice(0, 0, {
        translateY: g
      }), t.splice(0, 0, {
        translateX: a
      }), t.push({
        translateX: -a
      }), t.push({
        translateY: -g
      });
    }
  }
  return i;
};
function fe() {
  return fe = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var t = arguments[n];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
    }
    return e;
  }, fe.apply(this, arguments);
}
const ce = {
  x: "translateX",
  y: "translateY",
  scale: "scale",
  scaleX: "scaleX",
  scaleY: "scaleY",
  skewX: "skewX",
  skewY: "skewY",
  perspective: "perspective",
  rotate: "rotate",
  rotateX: "rotateX",
  rotateY: "rotateY",
  rotateZ: "rotateZ",
  matrix: "matrix"
}, An = {
  opacity: "opacity"
}, he = {
  x: 0,
  y: 0,
  scale: 1,
  scaleX: 1,
  scaleY: 1,
  skewX: "0deg",
  skewY: "0deg",
  perspective: 0,
  rotate: "0deg",
  rotateX: "0deg",
  rotateY: "0deg",
  rotateZ: "0deg",
  matrix: [],
  opacity: 1
}, $n = {
  type: "tween",
  duration: an
}, ye = {
  linear: d.linear,
  easeIn: d.ease,
  easeInOut: d.inOut(d.ease),
  easeOut: d.out(d.ease),
  circIn: d.circle,
  circInOut: d.inOut(d.circle),
  circOut: d.out(d.circle),
  backIn: d.back(2),
  backInOut: d.inOut(d.back(2)),
  backOut: d.out(d.back(2))
};
function K() {
  const e = /* @__PURE__ */ new Set();
  for (let n = 0; n < arguments.length; n++) {
    const t = n < 0 || arguments.length <= n ? void 0 : arguments[n];
    if (t) {
      const r = Object.keys(t);
      for (let i = 0; i < r.length; i++)
        e.add(r[i]);
    }
  }
  return e;
}
function V(e) {
  return /* @__PURE__ */ Xe(function(t, r) {
    let {
      animate: i,
      animateProps: u,
      initial: o,
      initialProps: m,
      exit: v,
      transition: l,
      transformOrigin: a,
      style: g,
      onLayout: Y,
      whileTap: B,
      whileHover: D,
      onAnimationComplete: de,
      ...Ie
    } = t;
    const me = Ye({}), H = K(o, i, u, B, D, v), L = Object.assign({}, i);
    if (u && (K(H, u), Object.assign(L, u)), B || D) {
      const {
        pressed: s,
        hovered: O
      } = Be(je);
      D && (K(H, D), O && Object.assign(L, D)), B && (K(H, B), s && Object.assign(L, B));
    }
    v && K(H, v);
    const G = [...H], Te = G.map((s) => L[s]);
    De(() => {
      const s = me.current, O = !u && G.every((I) => !!An[I] || !!ce[I]);
      for (let I = 0; I < G.length; I++) {
        var b, ie;
        const c = G[I], ke = u?.[c] !== void 0;
        let _ = L[c];
        const F = (b = (ie = ke ? m?.[c] : o?.[c]) !== null && ie !== void 0 ? ie : _) !== null && b !== void 0 ? b : he[c];
        if (_ === void 0 && (_ = F ?? he[c]), !s[c] || s[c].value !== _) {
          const oe = k.isString(F), pe = k.isArray(F);
          if (!s[c]) {
            const T = oe || pe ? 1 : F, z = new h.Value(T);
            s[c] = {
              value: F,
              animValue: z,
              valueInterp: oe ? 1 : void 0
            };
          }
          let ae;
          if (oe || pe) {
            const T = s[c].valueInterp, z = s[c].value;
            s[c].interpolation = s[c].animValue.interpolate({
              inputRange: [0, 1],
              outputRange: T === 1 ? [_, z] : [z, _]
            }), s[c].valueInterp = ae = 1 - T, s[c].value = _;
          } else
            s[c].value = ae = _;
          const R = l?.[c] || l?.default || l || $n;
          k.isString(R.easing) && (R.easing = ye[R.easing]), k.isString(R.ease) && (R.ease = ye[R.ease]);
          const be = Object.assign({
            toValue: ae,
            useNativeDriver: O
          }, R);
          typeof requestAnimationFrame < "u" && requestAnimationFrame(() => {
            const T = de ? () => de(c) : void 0, {
              loop: z,
              type: Ae
            } = R;
            let N;
            Ae === "spring" ? N = h.spring(s[c].animValue, be) : N = h.timing(s[c].animValue, be), z !== void 0 && (N = h.loop(N, {
              iterations: z
            })), N.start(T);
          });
        }
      }
    }, Te);
    const J = {}, ve = {}, ue = [];
    Object.entries(me.current).forEach((s) => {
      let [O, b] = s;
      u?.[O] !== void 0 ? ve[O] = b.interpolation || b.animValue : ce[O] ? ue.push({
        key: O,
        value: b
      }) : J[O] = b.interpolation || b.animValue;
    }), ue.length && (J.transform = ue.map((s) => {
      let {
        key: O,
        value: b
      } = s;
      return {
        [ce[O]]: b.interpolation || b.animValue
      };
    }));
    const Ve = a ? kn(a, J.transform, Y) : Y;
    return /* @__PURE__ */ p.createElement(e, fe({
      style: [g, J],
      onLayout: Ve
    }, Ie, ve, {
      ref: r
    }));
  });
}
let _e;
(function(e) {
  e.View = V(h.View), e.Text = V(h.Text), e.FlatList = V(h.FlatList), e.Image = V(h.Image), e.ScrollView = V(h.ScrollView), e.SectionList = V(h.SectionList), e.Pressable = sn;
})(_e || (_e = {}));
export {
  _e as Motion
};
